import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { faqs } from '../mockData';
import { HelpCircle, MessageCircle, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

const FAQ = () => {
  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Header */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-4xl mx-auto text-center">
          <Badge className="bg-purple-100 text-purple-700 border-purple-200 mb-4">
            Hjælp & Support
          </Badge>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            <span className="bg-gradient-to-r from-blue-600 to-teal-500 bg-clip-text text-transparent">
              Ofte Stillede
            </span>
            <br />
            Spørgsmål
          </h1>
          <p className="text-xl text-gray-600">
            Find svar på de mest almindelige spørgsmål om RabatHub
          </p>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-none shadow-lg rounded-xl overflow-hidden bg-white"
              >
                <AccordionTrigger className="px-6 py-5 hover:no-underline hover:bg-gray-50 transition-colors">
                  <div className="flex items-center space-x-3 text-left">
                    <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-teal-400 rounded-lg flex items-center justify-center flex-shrink-0">
                      <HelpCircle className="w-5 h-5 text-white" />
                    </div>
                    <span className="font-semibold text-gray-900 text-lg">{faq.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5 pt-2">
                  <p className="text-gray-600 leading-relaxed pl-11">{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Contact Section */}
      <section className="px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Fandt Du Ikke Svaret?
            </h2>
            <p className="text-lg text-gray-600">
              Vores support team er klar til at hjælpe dig
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <Card className="border-none shadow-xl hover:shadow-2xl transition-shadow duration-200">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <MessageCircle className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Live Chat
                </h3>
                <p className="text-gray-600 mb-6">
                  Tal med vores support team i realtid
                </p>
                <Button className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white">
                  Start Chat
                </Button>
              </CardContent>
            </Card>

            <Card className="border-none shadow-xl hover:shadow-2xl transition-shadow duration-200">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <Mail className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Send Email
                </h3>
                <p className="text-gray-600 mb-6">
                  Vi svarer inden for 24 timer
                </p>
                <Button className="bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white">
                  Kontakt Os
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;